import * as React from 'react'
import { Col, Row } from '../../../ui/grid'
import { TraceSummarySingleView } from '../../../domain/TraceSummary'
import ShareTraceExpirationDate from './share-trace-expiration-date'

interface Props {
    traceSummary: TraceSummarySingleView
    duration: number
    onChangeDuration: (ev: React.ChangeEvent<any>) => void
    defaultRetentionDays: number
}

class ShareTraceFormSettings extends React.Component<Props> {
    public render = (): React.ReactNode => {
        return (
            <Row>
                <Col width={2}>
                    <label className="control-label tw-ml-8">Settings</label>
                </Col>
                <Col width={3}>
                    <div className="form-group">
                        <label htmlFor="trace_duration" className="control-label">
                            Duration
                        </label>
                        <div className="input-group">
                            {!this.props.traceSummary.hasActiveShare && (
                                <select
                                    name="duration"
                                    id="trace_duration"
                                    className="form-control"
                                    style={{ display: 'inline-block', width: 'auto' }}
                                    onChange={ev => this.props.onChangeDuration(ev)}
                                    value={this.props.duration}
                                    disabled={this.props.traceSummary.hasActiveShare}
                                >
                                    <option value={1}>1 day</option>
                                    <option value={7}>1 week</option>
                                    <option value={30}>1 month</option>
                                    <option value={0}>Unlimited</option>
                                    <option value={this.props.defaultRetentionDays}>Until end of Trace retention</option>
                                </select>
                            )}
                            <ShareTraceExpirationDate duration={this.props.duration} traceSummary={this.props.traceSummary} />
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ShareTraceFormSettings
